import axios from "axios";
import qs from "qs";
import { Service } from "../interfaces/service.js";
class ApiAdapter extends Service {
  instance;
  constructor(baseUrl) {
    super();
    if (baseUrl === null || baseUrl === void 0) {
      throw new Error("baseUrl is missing!");
    }
    this.instance = axios.create({
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json"
      },
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    });
  }
  delete(path, config) {
    return this.instance.delete(path, config);
  }
  get(path, config) {
    return this.instance.get(path, config);
  }
  patch(path, data, config) {
    return this.instance.patch(path, data, config);
  }
  patchForm(path, data, config) {
    return this.instance.patchForm(path, data, config);
  }
  post(path, data, config) {
    return this.instance.post(path, data, config);
  }
  postForm(path, data, config) {
    return this.instance.postForm(path, data, config);
  }
  put(path, data, config) {
    return this.instance.put(path, data, config);
  }
  putForm(path, data, config) {
    return this.instance.putForm(path, data, config);
  }
  removeInterceptorRequest(id) {
    return this.instance.interceptors.request.eject(id);
  }
  removeInterceptorResponse(id) {
    return this.instance.interceptors.response.eject(id);
  }
  setInterceptorRequestHeaders(onFulfilled, onRejected) {
    return this.instance.interceptors.request.use(onFulfilled, onRejected);
  }
  setInterceptorResponseHeaders(onFulfilled, onRejected) {
    return this.instance.interceptors.response.use(onFulfilled, onRejected);
  }
  generateCancelRef() {
    return axios.CancelToken.source();
  }
}
export {
  ApiAdapter
};
//# sourceMappingURL=api.adapter.js.map
